import LookupContentStatusRequestModelBase from '../_generated/modelBases/lookup-content-status-request-model-base';

export default class LookupContentStatusRequestModel extends LookupContentStatusRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
